var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "box",
      style: {
        width: _vm.width,
        minWidth: "130px",
        margin: "4px",
        backgroundColor: this.localValue ? _vm.checkedColor : "#fff",
        marginLeft: "10px",
      },
    },
    [
      _c(
        "a-row",
        { attrs: { type: "flex" } },
        [
          _c("a-col", { attrs: { flex: "auto" } }, [_vm._v(_vm._s(_vm.label))]),
          _c(
            "a-col",
            { attrs: { flex: "30px" } },
            [
              _c("a-checkbox", {
                attrs: { disabled: _vm.disabled, checked: _vm.localValue },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.disabled
        ? _c("div", {
            staticStyle: {
              position: "absolute",
              width: "100%",
              height: "40px",
              top: "0",
              left: "0",
              "z-index": "1",
            },
          })
        : _c("div", {
            staticStyle: {
              position: "absolute",
              width: "100%",
              height: "40px",
              cursor: "pointer",
              top: "0",
              left: "0",
              "z-index": "1",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onChange.apply(null, arguments)
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }